import React, { useState, useEffect } from 'react';
import { useSelector } from 'react-redux';
import './add-user-details-form.scss';
import { Form } from '@ampol/design-system';
import { addUserDetailsFormSchema } from 'schemas/user-schemas';
import { useDisabledFields } from 'forms/hooks/useDisabledFields';

/**
 * Add New User - User details form
 * @returns JSX Element
 */
const AddUserDetailsForm = ({ formId, onSubmit, userDetails }) => {
  const userEmailLookup = useSelector((state) => state.userStore.userEmailLookup);
  const userEmailLookupLoaded = useSelector((state) => state.userStore.userEmailLookupLoaded);

  const { disableFields } = useDisabledFields();

  const [formValues, setFormValues] = useState({
    firstName: userDetails?.firstName ? userDetails.firstName : '',
    lastName: userDetails?.lastName ? userDetails.lastName : '',
  });

  useEffect(() => {
    if (userEmailLookupLoaded) {
      setFormValues({
        firstName: userEmailLookup.user?.givenName ? userEmailLookup.user.givenName : formValues.firstName,
        lastName: userEmailLookup.user?.familyName ? userEmailLookup.user.familyName : formValues.lastName,
      });
    }
  }, [userEmailLookupLoaded]);

  const onAddUserFormChange = (values) => {
    setFormValues({ ...formValues, ...values });
  };

  return (
    <>
      <Form
        id={formId}
        schema={addUserDetailsFormSchema}
        onSubmit={onSubmit}
        onChange={onAddUserFormChange}
        defaultValues={formValues}
      >
        <div className="add-user-details-form__form-contents">
          <div className="add-user-details-form__input">
            <Form.Input label={'First Name'} name={'firstName'} disabled={disableFields} />
          </div>
          <div className="add-user-details-form__input">
            <Form.Input label={'Last Name'} name={'lastName'} disabled={disableFields} />
          </div>
        </div>
      </Form>
    </>
  );
};

export default AddUserDetailsForm;
